// create a skeleton component ExerciseSkeleton for ExercisesTable using tailwincss
import Container from "../../../../components/container";

export default function ExerciseSkeleton() {
  return (
    <Container className="max-w-6xl text-left">
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-32 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-8 w-16 rounded bg-gray-100"></div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 rounded bg-gray-100"></div>
        <div className="h-10 w-32 rounded bg-gray-100"></div>
      </div>
    </Container>
  );
}

 
